import React, { ComponentProps } from "react";
import { IonButton } from '@ionic/react';

import './Button.scss';

interface IButtonProps extends ComponentProps<typeof IonButton> {
    navigate?: never;
    rounded?: boolean;
    uppercase?: boolean;
}

function Button(props: IButtonProps) {
    return (
        <div className="button-wrapper">
            <IonButton
                className={`${props.rounded ? "rounded" : ""} ${props.uppercase ? "uppercase" : ""}`}
                onClick={props.onClick}
                {...props}
            >
                {props.children}
            </IonButton>
        </div>
    )
}

export default Button;
